export enum ProjectAction {
  None = 0,
  Refresh = 1,
}
